import React, { useState, useContext } from "react";
import { graphql, StaticQuery } from "gatsby";
import { FormattedMessage } from "gatsby-plugin-react-intl";

import NavMenu from "../NavMenu";
import BarMenu from "../BarMenu";

import ThemeContext from "../../context/ThemeContext";
import HeaderBarContext from "../../context/HeaderBarContext";

import InternalLinks from "../../utils/internalLinks";

import primaryBackground from "../../img/card-backgrounds/primary.jpg";
import secondaryBackground from "../../img/card-backgrounds/secondary.jpg";
import tertiaryBackground from "../../img/card-backgrounds/tertiary.jpg";

import {
  Container,
  BarMenuContainer,
  ConstellationLogo,
  Nav,
  NavLink,
  BarsButton,
  Bars,
  CloseIcon,
  GetDagLink,
  GlowingCircle,
} from "./styles";

const HeaderTemplate = ({ data }) => {
  const [showBarOptions, setShowBarOptions] = useState(false);

  const { toggleDark } = useContext(ThemeContext);
  const { toggleOpened } = useContext(HeaderBarContext);

  if (!data || !data.allMarkdownRemark) {
    return <></>;
  }

  const backgrounds = {
    primary: primaryBackground,
    secondary: secondaryBackground,
    tertiary: tertiaryBackground,
  };

  const {
    title,
    date,
    description,
    number,
    redirectlink,
    redirectmessage,
    background_image,
  } = data.allMarkdownRemark.edges[0].node.frontmatter;

  const backGroundImage = backgrounds[background_image];

  return (
    <>
      <Container>
        <Nav showBarOptions={showBarOptions}>
          <NavLink to={InternalLinks.HOME}>
            <ConstellationLogo showBarOptions={showBarOptions}/>
          </NavLink>
          <BarsButton showBarOptions={showBarOptions}
            type="button"
            onClick={() => {
              toggleDark();
              toggleOpened();
              setShowBarOptions(!showBarOptions);
            }}
          >
            {showBarOptions ? <CloseIcon /> : <Bars />}
          </BarsButton>

          <NavMenu
            title={title}
            date={date}
            number={number}
            description={description}
            redirectlink={redirectlink}
            redirectmessage={redirectmessage}
            backgroundImage={backGroundImage}
          />
          <GetDagLink to={InternalLinks.GET_DAG}>
            <span>
              <FormattedMessage id="get_dag" />
            </span>
            <GlowingCircle />
          </GetDagLink>
        </Nav>
      </Container>
      {showBarOptions && (
        <BarMenuContainer>
          <BarMenu
            title={title}
            date={date}
            number={number}
            description={description}
            redirectlink={redirectlink}
            redirectmessage={redirectmessage}
            backgroundImage={backGroundImage}
          />
        </BarMenuContainer>
      )}
    </>
  );
};

const Header = ({ links }) => {
  return (
    <StaticQuery
      query={graphql`
        query HeaderHighlighQuery {
          allMarkdownRemark(
            limit: 1
            filter: { frontmatter: { templateKey: { eq: "header-highlight" } } }
          ) {
            edges {
              node {
                frontmatter {
                  title
                  description
                  date(formatString: "MMMM DD, YYYY")
                  number
                  background_image
                  redirectlink
                  redirectmessage
                }
              }
            }
          }
        }
      `}
      render={(data, count) => <HeaderTemplate data={data} />}
    />
  );
};

export default Header;
